import {exeRequest} from '../utils/APIUtils'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    get : async  () => exeRequest(`/admin/categories`, "GET"),

    post: async (data) => exeRequest(`/admin/categories`, "POST", data),

    delete: async (id) => exeRequest(`/admin/categories/${id}`, "DELETE"),

    put: async (id, data) => exeRequest(`/admin/categories/${id}`, "PUT", data),

    toggle: async (id, isActive) => exeRequest(`/admin/categories/${id}/toggle`, "PATCH", { isActive }),

}